module.exports = new __parcel__URL__("Medicomart_Logo.409be29a.png").toString();